const AuthRoot = () => import('@/views/AuthRoot.vue')
const LoginScreen = () => import('../components/LoginScreen.vue')
const ForgotPassword = () => import('../components/signup/ForgotPassword.vue')
const ResetPassword = () => import('../components/signup/ResetPassword.vue')
const AccountManagement = () => import('../components/signup/AccountManagement.vue')
const EmailVerificationConfirmation = () =>
  import('../components/EmailVerificationConfirmation.vue')
const StripeCheckoutStandalone = () =>
  import('@/components/subscriptions/StripeCheckoutStandalone.vue')

export const AuthPages = {
  Login: {
    path: '/login',
    name: 'login',
    component: LoginScreen,
    meta: { requiresAuth: false, hideNavbar: true },
  },
  ForgotPassword: {
    path: '/forgot-password',
    name: 'forgot-password',
    component: ForgotPassword,
    meta: { requiresAuth: false, hideNavbar: true },
  },
  ResetPassword: {
    path: '/reset-password',
    name: 'reset-password',
    component: ResetPassword,
    meta: { requiresAuth: false, hideNavbar: true },
  },
  AccountManagement: {
    path: '/account-management',
    name: 'account-management',
    component: AccountManagement,
    meta: { requiresAuth: false, hideNavbar: true },
  },
  EmailVerificationConfirmation: {
    path: '/email-verification',
    name: 'email-verification',
    component: EmailVerificationConfirmation,
    meta: { requiresAuth: false, hideNavbar: true },
  },
  StripeCheckoutStandalone: {
    path: '/stripe-checkout-standalone',
    name: 'stripe-checkout-standalone',
    component: StripeCheckoutStandalone,
    meta: { requiresAuth: false },
  },
}

export const AUTH_ROUTES = {
  path: '/auth',
  name: 'auth',
  component: AuthRoot,
  children: Object.values(AuthPages),
}
